module.exports = __webpack_public_path__ + "static/4_tablet-45b143f7e91158519dad056dbb226789.jpg";